import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface Category {
  name: string
  hasShoes: boolean | null
}

interface CategoryStore {
  currentCategory: Category | undefined
  setCurrentCategoryName: (currentCategoryName: string) => void
  setCurrentCategoryHasShoes: (currentCategoryHasShoes: boolean | null) => void
}

export const useCategoryStore = create<CategoryStore>()(
  devtools(
    (set) => {
      return {
        currentCategory: {
          name: '',
          hasShoes: null,
        },
        setCurrentCategoryName: (name) => {
          set((state) => {
            return {
              currentCategory: {
                name,
                hasShoes: state.currentCategory?.hasShoes ?? null,
              },
            }
          })
        },
        setCurrentCategoryHasShoes: (hasShoes) => {
          set((state) => {
            return {
              currentCategory: {
                hasShoes,
                name: state.currentCategory?.name ?? '',
              },
            }
          })
        },
      }
    },
    {
      name: 'Category Store',
    },
  ),
)
